/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Plan_Suggestion_Split_TransitionInputs */

const en_us2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks in and consistent, so your plan is ready to move to an upper/lower split`)
};

const pt_br2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas com constância: seu plano está pronto para dividir em superior/inferior`)
};

const es_419_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas de constancia: tu plan está listo para dividirse en tren superior/inferior`)
};

const pt_pt2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas com constância: o teu plano está pronto para dividir em superior/inferior`)
};

const fr_fr2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines de régularité : ton programme est prêt à passer en haut/bas du corps`)
};

const de_de2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen dabei und beständig: Dein Plan ist bereit für einen Ober-/Unterkörper-Split`)
};

const it_it2_plan_suggestion_split_transition = /** @type {(inputs: Plan_Suggestion_Split_TransitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane di costanza: la tua scheda è pronta per passare a uno split superiore/inferiore`)
};

/**
* | output |
* | --- |
* | "{weeks} weeks in and consistent, so your plan is ready to move to an upper/lower split" |
*
* @param {Plan_Suggestion_Split_TransitionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_split_transition = /** @type {((inputs: Plan_Suggestion_Split_TransitionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_Split_TransitionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_split_transition(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_split_transition(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_split_transition(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_split_transition(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_split_transition(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_split_transition(inputs)
	return en_us2_plan_suggestion_split_transition(inputs)
});
export { plan_suggestion_split_transition as "plan.suggestion.split_transition" }